module.exports = __webpack_public_path__ + "img/banner2@2x.1ee246ff.png";